import { load } from '@/router/routes/index';

export default [
    {
        path: 'vacations',
        name: 'vacation.index',
        component: load('vacation/VacationIndex'),
        meta: { auth: true },
    },
    {
        path: 'vacations/create',
        name: 'vacation.create',
        component: load('vacation/VacationCreate'),
        meta: { auth: true, forceCollapsedMenu: true },
    },
    {
        path: 'vacations/edit',
        name: 'vacation.edit',
        component: load('vacation/VacationEdit'),
        meta: { auth: true, forceCollapsedMenu: true },
    },
    {
        path: 'vacations/events/edit',
        name: 'vacation-event.edit',
        component: load('calendar/EventEdit'),
        meta: { auth: true, forceCollapsedMenu: true },
    },
    {
        path: 'vacations/vacation-event/create',
        name: 'vacation-event.create',
        props: true,
        component: load('calendar/EventCreate'),
        meta: { auth: true, forceCollapsedMenu: true },
    },
    {
        path: 'user-vacation-hours',
        name: 'uservacationhour.index',
        component: load('vacation/UserVacationHourIndex'),
        meta: { auth: true },
    },
    {
        path: 'user-vacation-hours/create',
        name: 'uservacationhour.create',
        component: load('vacation/UserVacationHourCreate'),
        meta: { auth: true, forceCollapsedMenu: true },
    },
    {
        path: 'vacations/calendar',
        name: 'vacation.calendar',
        component: load('vacation/VacationCalendar'),
        meta: { auth: true, forceCollapsedMenu: true, isMenuHidden: true },
    },
];
